import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, NavigationExtras, Router } from '@angular/router';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ApiService } from 'src/app/api.service';
import { DatePipe } from '@angular/common';
import { SecurityDocument } from 'src/app/shared/models/SecurityDocument';
import { TovpilUtilsService } from 'src/app/utils/tovpil-utils.service';
import { TracingWokrshopsVO } from 'src/app/shared/vo/TracingWokrshopsVO';
import { PeriodsVO } from 'src/app/shared/models/PeriodsVO';
import { TranslateRelLabelVO } from 'src/app/shared/models/TranslateRelLabelVO';

@Component({
  selector: 'app-tracing-workshops',
  templateUrl: './tracing-workshops.component.html',
  styleUrls: ['./tracing-workshops.component.scss'],
  providers: [MessageService, ConfirmationService]
})
export class TracingWorkshopsComponent implements OnInit {

  lstRespTranslate: TranslateRelLabelVO[];
  lbl_select: string = "select_";
  lbl_period: string = "period_";
  lbl_search: string = "search_";
  lbl_back: string = "back_";
  lbl_coordination: string = "coordination_";
  lbl_name: string = "name_";
  lbl_email: string = "email_";
  lbl_contact: string = "contact_";
  lbl_cell_phone: string = "cell_phone_";
  lbl_number_of_workshops: string = "number_of_workshops_";
  lbl_number: string = "number_";
  lbl_participants: string = "participants_";
  lbl_following_up: string = "following_up_";
  lbl_youngs: string = "youngs_";
  lbl_adults: string = "adults_";
  lbl_marriage_courses: string = "marriage_courses_";
  lbl_stages: string = "stages_";
  lbl_children: string = "children_";
  lbl_adolescents: string = "adolescents_";
  lbl_title: string = "title_";
  lbl_services: string = "services_";
  lbl_loading: string = "loading_";
  lbl_showing: string = "showing_";
  lbl_of: string = "of_";
  lbl_records: string = "records_";
  lbl_total: string = "total_";
  lbl_updated_data: string = "updated_data_";


  token: string;
  security: SecurityDocument;
  workShopsTracing: TracingWokrshopsVO[];
  blocked: boolean = true;
  listPeriods: PeriodsVO[];
  selectedPeriod: PeriodsVO;
  selSerTyp: string;
  selecStores: string;


  constructor(private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private apiService: ApiService,
    public datepipe: DatePipe,
    private route: ActivatedRoute,
    private router: Router,
    private tovpilUtils: TovpilUtilsService) {
    this.selectedPeriod = null;
    const navigation = this.router.getCurrentNavigation();
    this.route.queryParams
      .subscribe(
        params => {
          this.token = params.token;
          this.selSerTyp = params.selSerTyp;
          this.selecStores = params.selecStores;
          const dataParent = navigation.extras.state;
          if (dataParent) {
            this.selectedPeriod = dataParent.period as PeriodsVO;
          }
          this.getSecurity();
        });

  }

  ngOnInit(): void {
  }
  getWorkShops() {

    var lstSerTyp: string[];
    var storeId: string;
    this.blocked = true;
    if (this.selSerTyp == "youngs") {
      lstSerTyp = ["03"];
      // this.lbl_title = this.lbl_following_up + ' ' + this.lbl_youngs;
    } else if (this.selSerTyp == "sfpg") {
      lstSerTyp = ["16", "17", "18"];
      // this.lbl_title = this.lbl_following_up + ' ' + this.lbl_school_preparing_guides;
    } else if (this.selSerTyp == "youngTeens") {
      lstSerTyp = ["04"];
    } else if (this.selSerTyp == "children") {
      lstSerTyp = ["05"];
    } else {
      lstSerTyp = [this.selSerTyp];
    }
    if (!this.selecStores) {
      storeId = this.security.storeId;
    } else {
      let stores = this.selecStores.split("-");
      if (stores.length > 1) {
        storeId = stores[stores.length - 1];
      } else {
        storeId = this.selecStores;
      }
    }
    const payload = {
      "year": this.selectedPeriod.year,
      "period": this.selectedPeriod.period,
      "lstSerTyp": lstSerTyp,
      "storeId": storeId
    }
    this.apiService.getTracingWorkShop(payload).then(
      data => {
        this.workShopsTracing = data;
        this.messageService.add({ severity: 'success', summary: this.lbl_services, detail: this.lbl_updated_data, life: 3000 });
      }).catch(error => {
        console.error(error);
      }).finally(() => {
        setTimeout(() => {
          this.blocked = false;
        }, 1500)
      });
  }

  redirectDetail(workshop: TracingWokrshopsVO) {
    if (!this.selecStores) {
      this.selecStores = workshop.storeId;
    } else {
      this.selecStores = this.selecStores + "-" + workshop.storeId;
    }

    const objToSend = { workshop: workshop, token: this.token, period: this.selectedPeriod, selSerTyp: this.selSerTyp, selecStores: this.selecStores }
    let navigationExtras: NavigationExtras = {
      state: JSON.parse(JSON.stringify(objToSend))
    }
    this.router.navigate(['reports/tracingWorkshopDetail'], navigationExtras);
  }
  storeDrillDown(workshop: TracingWokrshopsVO) {

    if (!this.selecStores) {
      this.selecStores = workshop.storeId;
    } else {
      this.selecStores = this.selecStores + "-" + workshop.storeId;
    }

    let params = {};
    if (this.workShopsTracing) {
      params["token"] = this.token;
      params["selSerTyp"] = this.selSerTyp;
      params["selecStores"] = this.selecStores;
    }

    const objToSend = { period: this.selectedPeriod }
    let navigationExtras: NavigationExtras = {
      state: JSON.parse(JSON.stringify(objToSend)),
      queryParams: params
    }

    this.router.navigate(['reports/tracingWorkshops'], navigationExtras);
  }

  getValidPeriods() {

    this.apiService.getValidPeriods(this.security.language).then(
      data => {
        this.listPeriods = data;

        if (!this.selectedPeriod) {
          this.selectedPeriod = this.listPeriods[0];
        }


        this.getWorkShops();
      });
  }

  goBackClose() {
    if (!this.selecStores) {
      window.close();
    } else {
      let stores = this.selecStores.split("-");
      this.selecStores = "";
      if (stores.length > 1) {

        for (let ct = 0; ct < stores.length - 1; ct++) {
          this.selecStores = this.selecStores + stores[ct] + "-";
        }
        this.selecStores = this.selecStores.substring(0, this.selecStores.length - 1);
      } else {
        if (this.selecStores == "-") {
          this.selecStores = null;
        } else {
          this.selecStores = null;
        }
      }
      let params = {};
      if (this.workShopsTracing) {
        params["token"] = this.token;
        params["selSerTyp"] = this.selSerTyp;
        params["selecStores"] = this.selecStores;
      }

      const objToSend = { period: this.selectedPeriod }
      let navigationExtras: NavigationExtras = {
        state: JSON.parse(JSON.stringify(objToSend)),
        queryParams: params
      }

      this.router.navigate(['reports/tracingWorkshops'], navigationExtras);


    }
  };


  getSecurity() {
    if (this.token) {
      this.apiService.findSecurityById({ "id": this.token }).then(
        data => {
          this.security = data;
          this.getTranslatedLabels();
          this.getValidPeriods();

        }).catch(error => {
          console.error(error);
        });
    }

  }
  getTranslatedLabels() {
    let map = new Map();

    this.apiService.listByLanguageMultFields(
      {
        'language': this.security.language,
        'region': this.security.region,
        'lstLabels': [this.lbl_period, this.lbl_search, this.lbl_select, this.lbl_back, this.lbl_coordination, this.lbl_name, this.lbl_email, this.lbl_contact, this.lbl_cell_phone, this.lbl_number_of_workshops, this.lbl_participants, this.lbl_following_up, this.lbl_youngs, this.lbl_stages, this.lbl_children, this.lbl_adolescents, this.lbl_services, this.lbl_number, this.lbl_loading, this.lbl_showing, this.lbl_of, this.lbl_records, this.lbl_total, this.lbl_updated_data, this.lbl_adults, this.lbl_marriage_courses]
      }
    ).then(
      trDocs => {
        this.lstRespTranslate = trDocs;

        trDocs.forEach((element) => {
          map.set(element.labelId, element.translation);
        });

        this.lbl_period = map.get(this.lbl_period);
        this.lbl_search = map.get(this.lbl_search);
        this.lbl_select = map.get(this.lbl_select);
        this.lbl_back = map.get(this.lbl_back);
        this.lbl_coordination = map.get(this.lbl_coordination);
        this.lbl_name = map.get(this.lbl_name);
        this.lbl_email = map.get(this.lbl_email);
        this.lbl_contact = map.get(this.lbl_contact);
        this.lbl_cell_phone = map.get(this.lbl_cell_phone);
        this.lbl_number_of_workshops = map.get(this.lbl_number_of_workshops);
        this.lbl_number = map.get(this.lbl_number);
        this.lbl_participants = map.get(this.lbl_participants);
        this.lbl_following_up = map.get(this.lbl_following_up);
        this.lbl_stages = map.get(this.lbl_stages);
        this.lbl_children = map.get(this.lbl_children);
        this.lbl_adolescents = map.get(this.lbl_adolescents);
        this.lbl_youngs = map.get(this.lbl_youngs);
        this.lbl_adults = map.get(this.lbl_adults);
        this.lbl_marriage_courses = map.get(this.lbl_marriage_courses);
        this.lbl_services = map.get(this.lbl_services);
        this.lbl_loading = map.get(this.lbl_loading);
        this.lbl_showing = map.get(this.lbl_showing);
        this.lbl_of = map.get(this.lbl_of);
        this.lbl_records = map.get(this.lbl_records);
        this.lbl_total = map.get(this.lbl_total);
        this.lbl_updated_data = map.get(this.lbl_updated_data);

        if (this.selSerTyp == "youngs") {
          this.lbl_title = this.lbl_services + ' ' + this.lbl_youngs;
        } else if (this.selSerTyp == "sfpg") {
          this.lbl_title = this.lbl_services + ' ' + this.lbl_stages;
        } else if (this.selSerTyp == "youngTeens") {
          this.lbl_title = this.lbl_services + ' ' + this.lbl_adolescents;
        } else if (this.selSerTyp == "children") {
          this.lbl_title = this.lbl_services + ' ' + this.lbl_children;
        }
        else if (this.selSerTyp == "02") {
          this.lbl_title = this.lbl_services + ' ' + this.lbl_adults;
        }
        else if (this.selSerTyp == "06") {
          this.lbl_title = this.lbl_services + ' ' + this.lbl_marriage_courses;
        }
      });
  }
}
